// Function loadEventTemplate loads the EventTemplate class by dynamically importing the js on demand if needed

export function loadEventTemplate($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="EventTemplate"]');

	if(!$wg) {
		// console.info('EventTemplate: no widget found');
		return Promise.reject('ArticleGallery widget not found in the parent element');
	}
	return import(/* webpackChunkName: "wg-event-template-chunk" */ '../widgets/eventTemplate').then(wg => {

		const { EventTemplate } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="EventTemplate"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new EventTemplate($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new EventTemplate($wg);
		}


	}).catch(error => error+'An error occurred while loading the EventTemplate widget');

}
